import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, Card, Spin, Typography } from 'antd';
import axios from 'axios';

const { Paragraph, Text } = Typography;

/**
 * OAuth callback только для HH.
 * Redirect URI в заявке HH: http://localhost:5173/oauth/callback
 * Avito использует client_credentials без redirect.
 */
const AvitoOAuthCallbackPage = () => {
    const [params] = useSearchParams();
    const [state, setState] = useState({
        loading: true,
        ok: false,
        message: '',
        details: null
    });

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            const code = params.get('code');
            const error = params.get('error');

            if (error) {
                if (!cancelled) {
                    setState({
                        loading: false,
                        ok: false,
                        message: `HH OAuth: ${error}`,
                        details:
                            params.get(
                                'error_description'
                            ) || null
                    });
                }
                return;
            }

            if (!code) {
                if (!cancelled) {
                    setState({
                        loading: false,
                        ok: false,
                        message:
                            'В URL нет параметра code',
                        details: null
                    });
                }
                return;
            }

            try {
                const token =
                    localStorage.getItem('token');
                const response = await axios.get(
                    '/api/hr/hh/oauth/callback',
                    {
                        params: { code },
                        headers: token
                            ? {
                                  Authorization: `Bearer ${token}`
                              }
                            : {},
                        withCredentials: true
                    }
                );

                if (!cancelled) {
                    setState({
                        loading: false,
                        ok: true,
                        message:
                            'Токен HH сохранён. Можно тестировать sync откликов.',
                        details: response.data
                    });
                }
            } catch (err) {
                if (!cancelled) {
                    setState({
                        loading: false,
                        ok: false,
                        message:
                            err.response?.data?.message ||
                            err.message ||
                            'Ошибка обмена code',
                        details:
                            err.response?.data || null
                    });
                }
            }
        };

        run();

        return () => {
            cancelled = true;
        };
    }, [params]);

    return (
        <div
            style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 24,
                background:
                    'linear-gradient(160deg, #f3f6f9, #e8eef5)'
            }}
        >
            <Card
                title="HH OAuth"
                style={{ width: 520, maxWidth: '100%' }}
            >
                {state.loading ? (
                    <Spin tip="Обмениваем code на токен…" />
                ) : (
                    <>
                        <Alert
                            type={
                                state.ok
                                    ? 'success'
                                    : 'error'
                            }
                            showIcon
                            message={state.message}
                            style={{ marginBottom: 16 }}
                        />
                        {state.details ? (
                            <Paragraph>
                                <Text code>
                                    {JSON.stringify(
                                        state.details,
                                        null,
                                        2
                                    )}
                                </Text>
                            </Paragraph>
                        ) : null}
                    </>
                )}
            </Card>
        </div>
    );
};

export default AvitoOAuthCallbackPage;
